import React from 'react';
import { withRouter } from 'react-router';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { DotList } from '@motorway/mw-highway-code';

import { sanitiseLinks, wordpressImgToImgixURL } from 'Utilities';
import { classNamePropType } from 'Utilities/propTypes';

import styles from './BlogPost.scss';

const BlogPost = ({
  author, className, content, date, noLink, slug = null, title, wordpressContent,
}) => {
  const history = useHistory();

  const linkClick = (e) => {
    const url = e.target.getAttribute('href');

    // Don't break middle-click or (meta|ctrl)+click (new tab)
    if (e.target.href && url.charAt(0) === '/' && !(e.button === 1 || e.metaKey || e.ctrlKey || e.shiftKey)) {
      e.preventDefault();
      history.push(url);
    }
  };
  return (
    <div className={cx(styles.component, className)} onClick={linkClick}>
      <div className={styles.header}>
        {noLink
          ? <h1 dangerouslySetInnerHTML={{ __html: title }} className={styles.postTitle} />
          : <h2><a dangerouslySetInnerHTML={{ __html: title }} href={slug || null} /></h2>}
        <DotList
          data-thc-dotlist
          narrow
          data={[
            { content: `${author.name}`, key: 'a' },
            { content: date, key: 'b' },
          ]}
        />
      </div>
      <div dangerouslySetInnerHTML={{ __html: sanitiseLinks(wordpressImgToImgixURL(content)) }} {...wordpressContent} />
    </div>
  );
};

BlogPost.propTypes = {
  author: PropTypes.shape({
    name: PropTypes.string,
  }).isRequired,
  className: classNamePropType,
  content: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  noLink: PropTypes.bool.isRequired,
  slug: PropTypes.string,
  title: PropTypes.string.isRequired,
  wordpressContent: PropTypes.shape({
    className: PropTypes.string,
  }).isRequired,
};

export default withRouter(BlogPost);
